import Node from "./Node";

class Acl {
  rootNode: Node;

  constructor() {
    this.rootNode = new Node("root", true);
  }

  allow(capability: string): void {
    this.rootNode.allow(capability.split("."));
  }

  isAllowed(capability: string): boolean {
    return this.rootNode.isAllowed(capability.split("."));
  }
}

export default Acl;
